import { debounceTime, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { NetworkStatus } from '@cbridge-utils/network';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { pricingRuleStoreSelector, PricingRuleAction, IPricingRule } from '@cbridge-packages/pricing-rules';
import {
  RulesManagementAction, rulesActiveSelector, hasRuleValidationErrorsSelector, RULE_VALIDATION_DEBOUNCE,
} from '@cbridge-modules/rules-management-page';

type IState =
  & IGetSelectorStateType<typeof rulesActiveSelector>
  & IGetSelectorStateType<typeof pricingRuleStoreSelector>;

export const validatePricingRulesEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    RulesManagementAction.removeRule,
    RulesManagementAction.restoreRule,
    RulesManagementAction.updateRule,
    RulesManagementAction.reorderRule,
  ),
  debounceTime(RULE_VALIDATION_DEBOUNCE),
  withLatestFrom(state$),
  filter(([, state]) => !hasRuleValidationErrorsSelector(state)),
  mergeMap(([, state]) => {
    const { networkStatus } = pricingRuleStoreSelector(state);
    if (networkStatus !== NetworkStatus.Done) {
      return [];
    }

    const rules = rulesActiveSelector(state);
    return [PricingRuleAction.validate.started(rules as IPricingRule[])];
  }),
);
